import React from 'react'

type Props = JSX.IntrinsicElements['video'] & {
	src: string
	poster?: string
	playbackRate?: number
}

function Video({ src, poster = '', controls = false, playsInline = true, playbackRate = 1, ...props }: Props) {
	const ref = React.useRef<HTMLVideoElement>(null)

	React.useEffect(() => {
		if (ref.current) {
			ref.current.playbackRate = playbackRate
		}
	}, [playbackRate])

	return (
		<video
			ref={ref}
			controls={controls}
			loop
			autoPlay
			width="100%"
			muted
			playsInline={playsInline}
			poster={poster}
			{...props}
		>
			<source src={src} type="video/mp4" />
		</video>
	)
}

export default Video
